import { useCallback, useEffect, useRef } from 'react';
import { FaCamera } from 'react-icons/fa';
import Webcam from 'react-webcam';
import { Button, Col, Row } from 'reactstrap';
import './styles.css';

interface WebCamProps {
  handleScreenshot: (base64: string | null) => void;
  type?: string | null;
  title: string;
  description: string;
  facingMode?: string;
  selfie?: boolean;
}

const WebCam: React.FC<WebCamProps> = ({
  handleScreenshot,
  type = null,
  title,
  description,
  facingMode = 'environment',
  selfie = false,
}) => {
  const videoConstraints = {
    facingMode,
  };

  const webcamRef = useRef<Webcam>(null);

  const handleCapture = useCallback(() => {
    if (webcamRef.current) {
      const base64 = webcamRef.current.getScreenshot();
      handleScreenshot(base64);
    }
  }, [webcamRef, handleScreenshot]);

  return (
    <>
      <Row className="mb-2">
        <Col className="text-center">
          <h2 className="text-primary">{title}</h2>
          <p>{description}</p>
        </Col>
      </Row>
      <Row className="m">
        <Col lg="12" className="text-center box-web-cam">
          <Webcam
            audio={false}
            height={500}
            screenshotQuality={1}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
            className="web-cam"
            style={{
              ...(selfie
                ? {
                    WebkitTransform: 'scaleX(-1)',
                    transform: 'scaleX(-1)',
                  }
                : {}),
            }}
            ref={webcamRef}
          >
            {() => (
              <>
                {selfie ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 565 350"
                    className="model-selfie"
                  >
                    <path
                      d="M282.83,266.07v-.5h0c-8.56-.11-19.66-5.37-30.11-14.43A91.58,91.58,0,0,1,227.27,215c-3.94-10.52-5.65-23.78-7.27-36.41h0l-.08-.57h0c-.42-3.5-.85-6.95-1.34-10.27-3.53-24.3.67-45.35,11.67-60.33,10.63-14.54,27.78-23.52,50.82-24h3.77c23.09.49,40.25,9.47,50.94,24,10.93,15,15.13,36,11.55,60.33h0c-.17,1.29-.35,2.62-.52,3.95-.28,2.07-.57,4.18-.82,6.32-1.6,12.79-3.35,26.3-7.36,37a91.33,91.33,0,0,1-25.46,36.11h0c-10.39,9.06-21.55,14.38-30.1,14.43h0"
                      fill="none"
                      stroke="#00FF00"
                      strokeWidth="3"
                    />
                  </svg>
                ) : null}
              </>
            )}
          </Webcam>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col sm="12" className="text-center">
          <Button
            className="rounded-circle p-1"
            onClick={() => handleCapture()}
            color="warning"
          >
            <FaCamera size={25} />
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default WebCam;
